import { useQuery } from 'react-query'

import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'

import { QueryKeys } from '../../../../../enums/queryKeys'
import { fetchSalesDocumentDraft } from '../../../query-api'

export const useFetchSalesDocumentDraft = (documentType: InvoiceDocumentType, draftId?: string) => {
  const {
    data: draft,
    isFetching,
    isLoading: isQueryLoading,
    ...rest
  } = useQuery(
    [QueryKeys.SalesDocumentDraft, draftId, documentType],
    () => fetchSalesDocumentDraft(draftId || '', documentType),
    {
      enabled: !!draftId,
    },
  )

  return { salesDocumentDraft: draft?.data, isLoading: isQueryLoading || isFetching, ...rest }
}
